import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { ClientService } from '../../../../services/client.service';
import { SendMessageRequest, CompatibilityCheckResult } from '@rubii/sdk-web-agent/src/types/agent';

@Component({
  selector: 'app-analysing',
  templateUrl: './analysing.component.html',
  styleUrls: ['./analysing.component.scss']
})
export class AnalysingComponent implements OnInit {

  clientId = '';
  filePath = '';
  isAnalysing = false;
  error: string | null = null;
  result: CompatibilityCheckResult | null = null;

  constructor(
    private route: ActivatedRoute,
    private router: Router,
    private client: ClientService,
  ) { }

  ngOnInit(): void {
    const uuid = this.route.snapshot.paramMap.get('uuid');
    if (!uuid) {
      this.router.navigate(['/datasources/custom/upload']);
      return;
    }
    this.clientId = uuid;
    this.filePath = sessionStorage.getItem('datasource-uploaded-file-path') || '';
    if (!this.filePath) {
      this.router.navigate(['/datasources/custom/upload']);
      return;
    }
    this.analyse();
  }

  async analyse(): Promise<void> {
    this.isAnalysing = true;
    this.error = null;

    const request = new SendMessageRequest();
    request.message = 'Can you check if this file can be imported as new dsp data source?';
    request.clientId = this.clientId;
    request.skill = 'datasource/media-file-import/compatibility-check';
    request.responseFormat = 'json';
    request.attachments = [this.filePath];

    try {
      this.result = await this.client.agent.sendJsonQuery<CompatibilityCheckResult>(request);
      sessionStorage.setItem('data-source-custom-file-analyse-result-' + this.clientId, JSON.stringify(this.result));
      this.router.navigate(['/datasources/custom/summary', this.clientId]);
    } catch (err) {
      console.error('Analysis failed:', err);
      this.error = 'Analysis failed. Please try again.';
    } finally {
      this.isAnalysing = false;
    }
  }
}